import React from "react";
import { Skeleton } from "@/components/ui";

const NUM_SKELETONS = 3;

export const StudentCardSkeleton = () => (
  <div
    role="gridcell"
    className="flex w-full min-w-[260px] flex-col gap-1 rounded-md border border-border bg-background p-4"
    data-testid="student-grid-card-skeleton"
  >
    <div className="relative h-[280px] w-full overflow-hidden rounded-md">
      <Skeleton className="h-full w-full" />
      <Skeleton className="absolute bottom-2 left-2 h-5 w-24 rounded-full" />
    </div>

    <div className="flex flex-col gap-4 pt-2">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-6 w-3/4 rounded" />

        <div className="flex flex-col gap-3">
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-4 w-1/3" />
        </div>
      </div>

      <div className="mt-2 flex flex-wrap gap-x-1 gap-y-2">
        {Array.from({ length: NUM_SKELETONS }).map((_, i) => (
          <Skeleton key={i} className="h-5 w-[60px] rounded-full" />
        ))}
      </div>
    </div>
  </div>
);
